import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Chip, PageHeader, Spinner } from "@/components/rp";

const GROUPS = [
  ["appuntamenti", "Appuntamenti oggi e domani"], ["crono", "Lavorazioni in corso o in partenza"], ["prossimi_passi", "Prossimo passo per ogni cantiere"],
  ["sal", "SAL da approvare o fatturare"], ["scelte", "Scelte del cliente in scadenza"], ["materiali", "Consegne materiali in ritardo"],
  ["fermi", "Cantieri senza diario da 3 giorni"], ["pratiche", "Pratiche edilizie (CILA/SCIA, ASL)"], ["ritardi", "Cantieri in ritardo sulla fine lavori"],
  ["difetti", "Difetti scaduti"], ["preventivi", "Preventivi senza risposta da 7 giorni"],
];
const line = (k, r) => (k === "ritardi" ? `Fine prevista ${r.date} · ${r.days} giorni di ritardo` : k === "difetti" ? `${r.text} · ${r.responsabile || ""}` : r.text);
const TAB = { sal: "lavori", materiali: "lavori", scelte: "lavori", crono: "lavori", fermi: "diario", pratiche: "edilizia", difetti: "fine", ritardi: "edilizia" };
const href = (k, r) => (r.quote_id ? `/admin/preventivi/${r.quote_id}` : r.tab === "sopralluogo" ? "/admin/sopralluoghi" : `/admin/commesse/${r.order_id}${r.tab || TAB[k] ? `?tab=${r.tab || TAB[k]}` : ""}`);

export default function AdminOggi() {
  const [mine, setMine] = useState(false);
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/admin/oggi", { params: { mine } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, [mine]);
  return (
    <div className="space-y-6" data-testid="admin-oggi-page">
      <PageHeader label={new Date().toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" })} title={d ? `Buongiorno ${d.name.split(" ")[0]}, ecco cosa fare oggi` : "Oggi"} />
      <div className="flex gap-2">
        <Chip active={!mine} onClick={() => setMine(false)} data-testid="oggi-all">Tutti i cantieri</Chip>
        <Chip active={mine} onClick={() => setMine(true)} data-testid="oggi-mine">Solo i miei</Chip>
      </div>
      {!d ? <Spinner /> : (
        <div className="grid lg:grid-cols-2 gap-4">
          {GROUPS.filter(([k]) => d[k].length).map(([k, l]) => (
            <div key={k} className="rp-card p-5" data-testid={`oggi-${k}`}>
              <p className="rp-label mb-3">{l} · {d[k].length}</p>
              <div className="space-y-2">
                {d[k].slice(0, 12).map((r, i) => (
                  <Link key={i} to={href(k, r)} className="block rounded-2xl border border-[#EBEBEB] p-3 hover:border-black transition-colors" data-testid={`oggi-${k}-item-${i}`}>
                    <p className="text-sm font-medium">{r.code} · {r.title} <span className="text-[#757575] font-normal">· {r.client_name}</span></p>
                    <p className="text-xs text-[#757575] mt-0.5">{line(k, r)}</p>
                  </Link>
                ))}
              </div>
            </div>
          ))}
          {GROUPS.every(([k]) => !d[k].length) && <p className="text-sm text-[#757575]" data-testid="oggi-empty">Tutto in ordine per oggi.</p>}
        </div>
      )}
      <p className="text-xs text-[#757575]">Ogni mattina alle 8:30 lo staff riceve via email questo riepilogo; clienti e imprese ricevono i loro promemoria in automatico.</p>
    </div>
  );
}
